import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { CONSTANTS } from '../../../config';

@Component({
  selector: 'app-architecture-challenge-form',
  templateUrl: './architecture-challenge-form.component.html',
  styleUrls: ['./architecture-challenge-form.component.scss']
})
export class ArchitectureChallengeFormComponent {
  @Input() architectureChallengeForm!: FormGroup;
  @Input() allArchitectureTypes: any[] = [];
  @Input() allUsers: any[] = [];
  @Input() challengeParticipantFlag: boolean = false;
  @Input() architectureWinnersOptions: any[] = [];
  @Input() totalCompanyCreditsAvailable: any;
  @Input() architectureTicketError: string = '';
  @Input() errMessages: any = {};
  @Input() minDate: any;
  @Input() minEndDate: any;
  @Input() maxDate: any;
  @Input() updateFlag: boolean = false;

  @Output() ticketCalculation = new EventEmitter<void>();
  @Output() startDateChange = new EventEmitter<any>();
  @Output() resetForm = new EventEmitter<void>();
  @Output() postForm = new EventEmitter<boolean>();

  constructor(private fb: FormBuilder) {}

  get archTypeAndAmountGroupArray(): FormArray {
    return this.architectureChallengeForm.get('archTypeAndAmountGroup') as FormArray;
  }

  getArchitectureTypeSelectedItems(control: any): any[] {
    const ids: any[] = control ? control.value : [];
    if (!ids || ids.length === 0) { return []; }
    return this.allArchitectureTypes ? this.allArchitectureTypes.filter((t: any) => ids.includes(t.id)) : [];
  }

  onArchitectureTypeChange(control: any, selected: any[]): void {
    const ids = selected && selected.length ? selected.map((t: any) => t.id) : [];
    control.setValue(ids);
    control.markAsTouched();
  }

  addNewArchTypeAndAmountGroup() {
    this.archTypeAndAmountGroupArray.push(
      this.fb.group({
        architectureTypeId: [[], Validators.required],
        architectureBookingsToBeSold: ['', [Validators.required, Validators.pattern(CONSTANTS.regex.numeric)]],
      })
    );
  }

  removeGroup(index: number) {
    this.archTypeAndAmountGroupArray.removeAt(index);
  }

  isEmptyArchitectureUser(): boolean {
    if (!this.architectureChallengeForm) { return true; }
    const users = this.architectureChallengeForm.get('users');
    return !users || !users.value || users.value.length === 0;
  }
}
